<template>
  <div class="success-step">
    <div class="center-block">
      <img class="check-icon" src="@/ui/assets/icons/check-big.svg" />

      <div class="title">{{ $t('cmp.successStep.title') }}</div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'SuccessStep',
}
</script>

<style lang="scss">
.success-step {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  flex-grow: 1;

  .center-block {
    padding: 150px 40px;
    text-align: center;

    .check-icon {
      margin-bottom: 10px;
    }

    .title {
      font-size: 20px;
      margin-bottom: 30px;
    }
  }
}
</style>